import React from 'react';
import PropTypes from 'prop-types';
import router, {useRouter, withRouter} from 'next/router';
import dynamic from 'next/dynamic';
import { connect } from 'react-redux';
import Head from 'next/head';
import nextCookie from 'next-cookies';
const Hero = dynamic(() => import('../components/HomePage/Hero'))
import styles from '../components/HomePage/Home.module.css';
const Statistics = dynamic(() => import('../components/HomePage/Statistics'));
const Features = dynamic(() => import('../components/HomePage/Features'));
const FeedbackCarousel = dynamic(() => import('../components/HomePage/FeedbackCarousel'), {
  ssr: false,
});
const FaqAccordion = dynamic(() => import('../components/HomePage/FaqAccordion'), {
  ssr: false,
});
const Footer = dynamic(() => import('../components/HomePage/Footer'));
const Media = dynamic(() => import('../components/HomePage/Media'), {
  ssr: false,
});
const Awards = dynamic(() => import('../components/HomePage/Awards'));
const HowFaheemWorks = dynamic(() => import('../components/HomePage/HowFaheemWorks'));

import 'react-intl-tel-input/dist/main.css';
import { SnackbarProvider } from 'notistack';
import { getStages } from '../redux/actions/searchActions';
import Cookies from "js-cookie";


export const isAuth = (ctx) => {
  const { user_type, user_id } = nextCookie(ctx);
  return {
    user_type,
    user_id,
  };
};


class Page extends React.Component {
  static propTypes = {
    router: PropTypes.object.isRequired,
    resultsState: PropTypes.object,
    searchState: PropTypes.object,
  };

  state = {
    searchState: this.props.searchState,
    lastRouter: this.props.router,
    showHeroForm: false,
  };

  toggleHeroForm = () => {
    this.setState((prevState) => ({
      showHeroForm: !prevState.showHeroForm,
    }));
  };

  componentDidMount() {
    if (this.props.isAuth?.user_type !== 'tutor') {
      this.props.getStages();
    }

    if (this.props.isAuth?.user_type === 'tutor') {
      this.props.router.push('/tutor/orders', {
        shallow: true,
      });
    }
  }

  appleTab = (e) => {
    e.preventDefault();
    window.open(
      'https://apps.apple.com/sa/app/%D9%81%D9%87%D9%8A%D9%85-%D9%85%D9%86%D8%B5%D8%A9-%D9%81%D9%87%D9%8A%D9%85-%D8%A7%D9%84%D8%AA%D8%B9%D9%84%D9%8A%D9%85%D9%8A%D8%A9/id1363295457?l=ar',
      '_blank'
    );
  };

  googleTab = (e) => {
    e.preventDefault();
    window.open(
      'https://play.google.com/store/apps/details?id=com.faheemapp.android&hl=ar',
      '_blank'
    );
  };


  render() {
    const rToken = router.query.R;
    if (rToken) {
      Cookies.set('rToken', rToken);
    }
    return (
      <>
        <Head>
          <title>
            منصة فهيم افضل منصة عربية متخصصة في التعليم المدرسي والجامعي
          </title>
          <meta
            name="description"
            content="منصة تهتم في التعليم واساليب التعليم الحديثة والدروس الالكتروني"
          />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href="https://www.faheemapp.com/" />
          <meta property="og:locale" content="ar_AR" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="فهيم - موقع يقدم لكم خدمات حجز المعلمين  عن طريق الانترنت بكل سهولة"
          />
          <meta
            property="og:description"
            content="منصة تسهل عملية التعليم بشكل كبير وتساعدك على حجز المعلمين الأكفاء في كل مجال"
          />
          <meta property="og:url" content="https://www.faheemapp.com/" />
          <meta property="og:site_name" content="فهيم" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="فهيم - موقع يقدم لكم خدمات حجز المعلمين  عن طريق الانترنت بكل سهولة"
          />
          <meta
            name="twitter:description"
            content="فهيم - موقع يقدم لكم خدمات حجز المعلمين  عن طريق الانترنت بكل سهولة"
          />
          <link rel="stylesheet" href={'/assets/criticalcss/Rubik.css'} />
        </Head>
        <div className={styles.container}>
          <SnackbarProvider>
            <main className={styles.main}>
              <Hero
                showHeroForm={this.state.showHeroForm}
                setShowHeroForm={this.toggleHeroForm}
              />
              <Awards />
              <Statistics />
              <Features />
              <FeedbackCarousel />
              <HowFaheemWorks
                showHeroForm={this.state.showHeroForm}
                setShowHeroForm={this.toggleHeroForm}
              />
              <Media />
              <FaqAccordion />
              <Footer />
            </main>
          </SnackbarProvider>
        </div>
      </>
    );
  }
}

Page.getInitialProps = async ({ Component, ctx, ...rest }) => {
  return {
    isAuth: isAuth(rest),
  };
};

const mapStateToProps = (state) => ({
  userType: state.auth.currentUser?.user_type,
  userName: state.auth.currentUser?.username,
  user: state.auth.currentUser,
  stages: state.searchState.stages,
  subjects: state.searchState.subjects,
  subSubjects: state.searchState.subSubjects,
  searchState: state.searchState,
});

const ConnectedSearch = connect(mapStateToProps, {
  getStages,
})(Page);
export default withRouter(ConnectedSearch);
